import React from 'react';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import { Device } from 'api/InteractiveMap/types';

interface TempMarkerPopupProps {
  trap: Device;
  onMoveAction: (action: 'new_place') => void;
  isLoading?: boolean;
  isHub?: boolean;
}

export const TempMarkerPopup: React.FC<TempMarkerPopupProps> = ({ trap, onMoveAction, isLoading, isHub = false }) => {
  const { t } = useTranslation();
  return (
    <div className="trap-popup">
      <div className="trap-popup-header">
        <strong>
          {isHub
            ? t('Popups.HubPopup.title', { number: trap.number })
            : t('Popups.TempMarkerPopup.trapTitle', { number: trap.number })}
        </strong>
      </div>
      <div>{t('Popups.HubPopup.serialNumber', { slug: trap.slug })}</div>

      {/* Move Actions Row */}
      <div className="move-actions-row mt-2 text-center">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80px' }}>
            <ColorRing
              visible
              height="50"
              width="50"
              ariaLabel="color-ring-loading"
              wrapperStyle={{}}
              wrapperClass="color-ring-wrapper"
              colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
            />
          </div>
        ) : (
          <div className="mt-3">
            <button
              className="btn btn-link text-teal"
              style={{ textDecoration: 'none' }}
              onClick={() => onMoveAction('new_place')}
            >
              {t('Popups.TempMarkerPopup.savePosition')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
